import React from 'react';
import { useSelector } from 'react-redux';
import H1 from 'shared/app/components/h1';

import { signedInSelector } from 'shared/app/bundles/user';
import RewardsSubnav from './subnav';

const HowItWorks = () => {
  const signedIn = useSelector(signedInSelector);
  return (
    <React.Fragment>
      {signedIn && <RewardsSubnav />}
      <H1>How it Works</H1>
    </React.Fragment>
  );
};

export default HowItWorks;
